import { EventDrawerTabs } from '../../constants';

import { CheckIsLocationsTabType } from './interfaces';

export const checkIsLocationsTab: CheckIsLocationsTabType = (tab) =>
  tab === EventDrawerTabs.Locations;

export const checkIsParticipantsTab: CheckIsLocationsTabType = (tab) =>
  tab === EventDrawerTabs.Participants;
